import { MigrationJourneyCoverageArea } from '@/types/model/migrationCoverage';

// Keep these counts aligned with notes/descriptions/testing/migration-scenario-matrix.md.
export const migrationJourneyCoverageAreas: MigrationJourneyCoverageArea[] = [
  {
    id: 'core-shell-access',
    title: 'Core shell and access',
    totalJourneys: 8,
    automatedJourneys: 8,
    unitJourneys: 0,
    e2eJourneys: 8,
    primaryLayer: 'e2e',
    status: 'covered',
    nextFocus: 'Maintain smoke reliability and revisit A7 when true 404 behavior is introduced',
  },
  {
    id: 'inspection-operations',
    title: 'Inspection and operational workflows',
    totalJourneys: 23,
    automatedJourneys: 20,
    unitJourneys: 0,
    e2eJourneys: 20,
    primaryLayer: 'hybrid',
    status: 'in-progress',
    nextFocus: 'Inspection result approval flows, CA acceptance/reopening mutations, bulk action confirmations',
  },
  {
    id: 'admin-settings',
    title: 'Administration and settings',
    totalJourneys: 23,
    automatedJourneys: 20,
    unitJourneys: 0,
    e2eJourneys: 20,
    primaryLayer: 'hybrid',
    status: 'in-progress',
    nextFocus: 'Transactional approval workflows, audit logging, bulk admin operations, role-based access testing',
  },
  {
    id: 'shared-regression',
    title: 'Shared behavior and regression checks',
    totalJourneys: 6,
    automatedJourneys: 4,
    unitJourneys: 4,
    e2eJourneys: 4,
    primaryLayer: 'hybrid',
    status: 'in-progress',
    nextFocus: 'Permission-driven visibility gating, empty-state rendering',
  },
  {
    id: 'dashboard-navigation',
    title: 'Dashboard and navigation flows',
    totalJourneys: 15,
    automatedJourneys: 5,
    unitJourneys: 0,
    e2eJourneys: 5,
    primaryLayer: 'e2e',
    status: 'in-progress',
    nextFocus: 'Enterprise/module dashboards, permission-driven menu visibility, transaction logging views',
  },
  {
    id: 'utility-edge',
    title: 'Utility and edge flows',
    totalJourneys: 8,
    automatedJourneys: 0,
    unitJourneys: 0,
    e2eJourneys: 0,
    primaryLayer: 'unit',
    status: 'not-started',
    nextFocus: 'Feedback print flows, background messages, mobile shell edge cases',
  },
];